'use strict'
const  { merge } = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
    NODE_ENV: '"development"',
    // API_HOST: '"/api"'

    // 每次改环境要改8个文件（包括dist文件夹内有3个）

    // 测试环境
    // API_ROOT: '"https://testservice.tencloudnet.com"'
    // 研发环境
    // API_ROOT: '"http://new1.tencloudnet.com"'
    // 生产环境
    API_ROOT: '"https://service-web.szdreamerstech.com/"'

    // 导出http/https更改
})


//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1